export default "__VITE_ASSET__71c65272__"